import axios from "axios";
import { QueryFunctionContext, useQuery, UseQueryResult } from "react-query";
import { IStacFilter, IStacSearchResult } from "types/stac";
import { STAC_URL, API_VERSION } from "utils/constants";

export const useStacSearch = (
  search: IStacFilter | undefined,
  enabled?: boolean
): UseQueryResult<IStacSearchResult, Error> => {
  return useQuery(["items", search], getStacItems, {
    keepPreviousData: true, // intended to not clear out search results when panning the map
    enabled: !!search && Boolean(enabled),
  });
};

const getStacItems = async (
  queryContext: QueryFunctionContext<[string, IStacFilter | undefined]>
): Promise<IStacSearchResult> => {
  const [, search] = queryContext.queryKey;

  if (typeof search === "undefined") {
    return Promise.reject();
  }

  const resp = await axios.post(`${STAC_URL}/search`, search, {
    params: { "api-version": API_VERSION },
  });

  return resp.data;
};
